import React, { useState, useRef, useEffect } from 'react';
import { ChevronDownIcon, CheckIcon, MapPinIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const CityStep = ({ cities, selectedCity, onSelect, isDesktop = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const filteredCities = cities.filter(city =>
    city.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (city) => {
    onSelect(city);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className={`${isDesktop ? '' : 'max-w-md mx-auto'}`}>
      {!isDesktop && (
        <h3 className="mb-3 font-medium text-gray-800 dark:text-gray-100 text-base">
          Oraș
        </h3>
      )}
      
      <div className="relative" ref={dropdownRef}>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-3 text-left shadow-sm hover:shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <MapPinIcon className="h-5 w-5 text-purple-600 dark:text-purple-400" />
              {selectedCity ? (
                <span className="text-gray-900 dark:text-gray-100 font-medium">
                  {selectedCity}
                </span>
              ) : (
                <span className="text-gray-500 dark:text-gray-400">
                  Selectează orașul
                </span>
              )}
            </div>
            <ChevronDownIcon 
              className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
                isOpen ? 'rotate-180' : ''
              }`} 
            />
          </div>
        </button>

        {isOpen && (
          <div className="absolute z-30 w-full mt-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl">
            {/* Search Input */}
            <div className="p-3 border-b border-gray-200 dark:border-gray-700">
              <div className="relative">
                <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                <input
                  type="text"
                  placeholder="Caută oraș..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                />
              </div>
            </div>

            {/* Cities List */}
            <div className="max-h-60 overflow-y-auto py-2">
              {filteredCities.length > 0 ? (
                filteredCities.map((city) => (
                  <button
                    key={city}
                    onClick={() => handleSelect(city)}
                    className="w-full px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 flex items-center justify-between group"
                  >
                    <div className="flex items-center gap-3">
                      <MapPinIcon className="h-4 w-4 text-gray-400 group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors" />
                      <span className="text-gray-900 dark:text-gray-100">
                        {city}
                      </span>
                    </div>
                    {selectedCity === city && (
                      <CheckIcon className="h-5 w-5 text-purple-600 dark:text-purple-400" />
                    )}
                  </button>
                ))
              ) : (
                <div className="px-4 py-3 text-gray-500 dark:text-gray-400 text-center">
                  Nu s-au găsit orașe
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CityStep;
